// useFacebookPixel.js
import { useEffect, useRef } from "react";
import { loadPixel, normEmail, normName } from "./FbPixel";

// opts = {
//   pixelId: "1790472721766913",
//   user: { email, firstName, lastName }, // fill from your app when available
//   consentGiven: true, // gate under GDPR
//   firePageViewOnMount: true,
// };
export default function useFacebookPixel(opts) {
  const {
    pixelId,
    user = {},
    consentGiven = true,
    firePageViewOnMount = true,
  } = opts || {};
  const inited = useRef(false);

  useEffect(() => {
    if (!consentGiven || !pixelId) return;

    loadPixel();

    // Build Advanced Matching payload only with non-empty values.
    const am = {};
    if (user.email) am.em = normEmail(user.email);
    if (user.firstName) am.fn = normName(user.firstName);
    if (user.lastName) am.ln = normName(user.lastName);

    if (!inited.current) {
      window.fbq && window.fbq("init", pixelId, am); // hashes automatically
      inited.current = true;
      if (firePageViewOnMount) window.fbq && window.fbq("track", "PageView");
    } else if (Object.keys(am).length) {
      // If user data arrives later (e.g., after login), re-init merges identifiers.
      window.fbq && window.fbq("init", pixelId, am);
    }
  }, [
    pixelId,
    user.email,
    user.firstName,
    user.lastName,
    consentGiven,
    firePageViewOnMount,
  ]);

  const trackPageView = () => window.fbq && window.fbq("track", "PageView");
  const track = (eventName, params) =>
    window.fbq && window.fbq("track", eventName, params);

  return { trackPageView, track };
}
